import { createSelector } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { oneBoxV3Api } from '~/api/oneBoxV3';
import { TOneBoxV3GetRecordsPayload } from '~/api/oneBoxV3/oneBoxV3.type';
import { RootState } from '~/store';
import { endOfDate, startOfDate } from '~/utils/helper/format';

export const getterRecords = createSelector(
  [
    (state: RootState) => state.record.records,
    (state, params: TOneBoxV3GetRecordsPayload) =>
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      oneBoxV3Api.endpoints.getRecords.select(params)(state)?.data,
  ],
  (initialData, resourceData) => {
    if (
      resourceData &&
      resourceData.data &&
      resourceData.data.data.length > 0
    ) {
      return {
        records: resourceData.data.data,
        totalRecordsCount: resourceData.data.totalAmount,
      };
    }
    return {
      records: initialData,
      totalRecordsCount: 0,
    };
  },
);

export const getterAdminRecordsPayload = createSelector(
  (state: RootState) => state.record.searchCondition,
  ({ dateFrom, dateTo, page, pageSize }) => ({
    ...(dateFrom && { dateFrom: startOfDate(dayjs(dateFrom)) }),
    ...(dateTo && { dateTo: endOfDate(dayjs(dateTo)) }),
    pagination: {
      page,
      pageSize,
      sort: null,
    },
  }),
);

export const getterAdminRecordFilter = createSelector(
  (state: RootState) => state.record.searchCondition,
  ({ dateFrom, dateTo, page, pageSize, sort }) => ({
    dateFrom,
    dateTo,
    pagination: {
      pageSize,
      page,
      sort,
    },
  }),
);
